import { LangLabel } from "data/LangLabel";
import React, { Fragment } from "react";
import { ArrFrom } from "utils/MyUtils";

const DataPagination = (props) => {
  const { paging, changePage, ...rest } = props;
  const goToPage = (event, page) => {
    event.preventDefault();
    changePage(page);
  };
  return (
    <>
      {paging ? (
        <div className="row">
          <div className="col-sm-12 col-md-5">
            <div
              className="dataTables_info"
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              {LangLabel.LABEL_PAGINATION_COUNT} {paging?.count}
            </div>
          </div>
          <div className="col-sm-12 col-md-7">
            <div
              className="dataTables_paginate paging_simple_numbers"
              id="example1_paginate"
            >
              <ul className="pagination">
                <li
                  className={
                    paging.page === 1
                      ? "paginate_button page-item previous disabled"
                      : "paginate_button page-item previous"
                  }
                  id="awal"
                >
                  <a
                    onClick={(event) => goToPage(event, 1)}
                    href="#"
                    aria-controls="awal"
                    data-dt-idx={0}
                    tabIndex={0}
                    className="page-link"
                  >
                    {LangLabel.LABEL_FIRST}
                  </a>
                </li>
                <li
                  className={
                    Number(paging.page) <= 1
                      ? "paginate_button page-item previous disabled"
                      : "paginate_button page-item previous"
                  }
                  id="previous"
                >
                  <a
                    onClick={(event) =>
                      goToPage(event, Number(paging.page) - 1)
                    }
                    href="#"
                    aria-controls="previous"
                    data-dt-idx={1}
                    tabIndex={1}
                    className="page-link"
                  >
                    {LangLabel.LABEL_PREVIOUS}
                  </a>
                </li>
                {ArrFrom(1, Number(paging.total_page)).map((val, idx) => {
                  const total = Number(paging.total_page);
                  const current = Number(paging.page);
                  const tambahan1 = 6 - current > 0 ? 3 : 0;
                  const tambahan2 = total - current < 5 ? 3 : 0;
                  const tambah = tambahan1 + tambahan2;
                  const tengah = Math.floor(total / 2);
                  let pembagi = Math.ceil(total / 7);
                  pembagi = pembagi > 0 ? pembagi : 1;
                  //const kondisi = (val == tengah) || (val < 4 + tambah) || (val > total - 3 - tambah) || ((val > current - 3) && (val < current + 3))
                  const kondisi =
                    val == current ||
                    val == tengah ||
                    val <= 2 ||
                    val > total - 2 ||
                    val % pembagi === 0;
                  const cls =
                    val === paging.page
                      ? "paginate_button page-item active"
                      : "paginate_button page-item";
                  return (
                    kondisi && (
                      <li className={cls} key={idx}>
                        <a
                          onClick={(event) => goToPage(event, val)}
                          href="#"
                          aria-controls={"page-" + paging.page}
                          data-dt-idx={val}
                          tabIndex={val}
                          className="page-link"
                        >
                          {val}
                        </a>
                      </li>
                    )
                  );
                })}
                <li
                  className={
                    Number(paging.page) >= Number(paging.total_page)
                      ? "paginate_button page-item next disabled"
                      : "paginate_button page-item next"
                  }
                  id="next"
                >
                  <a
                    onClick={(event) =>
                      goToPage(event, Number(paging.page) + 1)
                    }
                    href="#"
                    aria-controls="next"
                    data-dt-idx={Number(paging.total_page)}
                    tabIndex={Number(paging.total_page)}
                    className="page-link"
                  >
                    {LangLabel.LABEL_NEXT}
                  </a>
                </li>
                <li
                  className={
                    paging.total_page === paging.page
                      ? "paginate_button page-item next disabled"
                      : "paginate_button page-item next"
                  }
                  id="akhir"
                >
                  <a
                    onClick={(event) => goToPage(event, paging.total_page)}
                    href="#"
                    aria-controls="akhir"
                    data-dt-idx={paging.total_page}
                    tabIndex={paging.total_page}
                    className="page-link"
                  >
                    {LangLabel.LABEL_LAST}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div className="box-footer clearfix">Data tidak tersedia</div>
      )}
    </>
  );
};

DataPagination.defaultProps = {
  paging: null,
  changePage: (page) => {},
};

export default DataPagination;
